import {Component, forwardRef, Input, Output, EventEmitter, OnInit} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, FormControl} from '@angular/forms';
import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import {CustomDateRange} from '../../../types/common.types';

@Component({
  selector: 'app-element-date-range',
  templateUrl: './element-date-range.component.html',
  styleUrls: ['./element-date-range.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ElementDateRangeComponent),
      multi: true
    }
  ]
})
export class ElementDateRangeComponent implements OnInit, ControlValueAccessor {
  @Input() label = 'Date Range';
  @Input() minDate: Date;
  @Input() maxDate: Date;
  @Input() defaultStartDate: Date;
  @Input() defaultEndDate: Date;
  @Input() hint: string;
  @Output() dateRangeChanged: EventEmitter<CustomDateRange | null> = new EventEmitter<CustomDateRange | null>();

  dateRange: FormGroup;

  private onChange = (_: any) => {};
  private onTouched = () => {};

  constructor(private fb: FormBuilder) {
    this.dateRange = this.fb.group({
      start: new FormControl<Date | null>(null),
      end: new FormControl<Date | null>(null),
    });
  }
  ngOnInit() : void {
    this.setDefaultDateRange();
  }

  setDefaultDateRange() : void {
    if (this.defaultStartDate && this.defaultEndDate) {
        this.dateRange.patchValue({
          start: this.defaultStartDate,
          end: this.defaultEndDate
        }, {emitEvent: false});
    }
  }

  onDateChange(type: 'start' | 'end', event: MatDatepickerInputEvent<Date>) {
    const value = this.dateRange.value;
    if (type === 'start') {
      value.start = event.value;
    }
    else {
      value.end = event.value;
    }

    this.onChange(value);
    this.onTouched();

    if (value.start && value.end) {
      this.dateRangeChanged.emit(value);
    }
    else if (!value.start && !value.end) {
      this.dateRangeChanged.emit(null);
    }
  }

  clearDateRange() {
    this.onChange(null);
    this.onTouched();
    this.dateRange.reset({start: null, end: null}, {emitEvent: false});
    this.dateRangeChanged.emit(null);
  }

  writeValue(value: CustomDateRange | null): void {
    if (value) {
      this.dateRange.patchValue(value, {emitEvent: false});
    }
    else {
      this.dateRange.reset({start: null, end: null}, {emitEvent: false});
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.dateRange.disable() : this.dateRange.enable();
  }

}
